// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { DeleteConfirmModal, DocumentViewingModal, Table } from ".";
import {
  GridActionsCellItem,
  GridColDef,
  GridPaginationModel,
} from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  useAuthorization,
  useDocumentDelete,
  useDocumentUpdate,
  useGetMerchantPaymentDetail,
  useGetCommissionListByMerchantId,
} from "../../hooks";
import { useSetSnackBar } from "../../store/Snackbar.state";
import { default as dayjs } from "dayjs";
import { downloadExcel } from "../../util/downloadExcel";
import Pagination from "@mui/material/Pagination";

export function CommissionDetailModal({ isOpen, handleClose, merchantId }) {
  const { showDelete, showUpdate } = useAuthorization();
  const theme = useTheme();
  const setSnackbar = useSetSnackBar();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [tableData, setTableData] = useState([]);
  const { mutate: getCommissionList } = useGetCommissionListByMerchantId();

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const { mutate: deleteDocument, isLoading: isDeleteLoading } =
    useDocumentDelete();

  const deleteRow = (id: number) => {
    setIsDeleteModalOpen(true);
    setSelectedRowId(id);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteDocumentRequest = { id: selectedRowId };

    deleteDocument(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          // Silme işlemi başarılı olduğunda tekrar liste çekilir.
          getCommissionList(
            { id: merchantId },
            {
              onSuccess: (data) => {
                if (data.isSuccess) {
                  setTableData(data.data);
                  setSnackbar({
                    severity: "success",
                    isOpen: true,
                    description: data.message,
                  });
                } else {
                  setSnackbar({
                    severity: "error",
                    description: data.message,
                    isOpen: true,
                  });
                }
              },
              onError: () => {
                setSnackbar({
                  severity: "error",
                  description: "Liste çekilirken bir hata oluştu",
                  isOpen: true,
                });
              },
            }
          );

          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    const req: GetMerchantPaymenDetailtRequest = {};

    getCommissionList(req, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      // {
      //   field: "Aksiyonlar",
      //   type: "actions",
      //   width: 80,
      //   getActions: (params) => {
      //     return [
      //       // !!showUpdate ? <GridActionsCellItem
      //       //   label="Düzenle"
      //       //   onClick={editRow(params.row)}
      //       //   showInMenu
      //       // /> : <></>,
      //       !!showDelete ? <GridActionsCellItem
      //         label="Sil"
      //         onClick={() => deleteRow(params.row.id)}
      //         showInMenu
      //       /> : <></>,
      //     ];
      //   },
      // },
      { field: "profileCode", headerName: "Profil Kodu", width: 180 },
      { field: "txnType", headerName: "İşlem Türü", width: 180 },
      { field: "bankcode", headerName: "Banka Kodu", width: 180 },
      {
        field: "onus",
        headerName: "Onus",
        width: 180,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
      },
      {
        field: "international",
        headerName: "International",
        width: 180,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
      },
      {
        field: "amex",
        headerName: "Yi Amex",
        width: 180,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
      },
      { field: "cardType", headerName: "Kart Tipi", width: 180 },
      {
        field: "commissionFlag",
        headerName: "Komisyonu Son Kullanıcıya Yansıt",
        width: 180,
        valueFormatter: (params) => (params.value ? "Evet" : "Hayır"),
      },
      {
        field: "merchantadditionalcommission",
        headerName: "Üye İşyeri Ek Komisyonu",
        type: 'decimalOnly',
        width: 180,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "merchantcommission",
        headerName: "Üye İşyeri Komisyon Oranı",
        type: 'decimalOnly',
        width: 180,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "minAmount",
        headerName: "Minimum Tutar",
        type: 'decimal',
        width: 180,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      {
        field: "maxAmount",
        headerName: "Maksimum Tutar",
        type: 'decimal',
        width: 180,
        valueFormatter: (params: GridValueFormatterParams<number>) => {
          if (params.value == null) {
            return "";
          }
          return `${params.value} TL`;
        },
      },
      { field: "installment", headerName: "Taksit Sayısı", width: 180 },
    ];
  }, [deleteRow, showDelete]);

  useEffect(() => {
    if (isOpen && merchantId) {
      getCommissionList(
        { id: merchantId },
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              setTableData(data.data);
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          },
        }
      );
    }
  }, [isOpen, merchantId]);

  const onSave = () => {
    getCommissionList(
      { id: merchantId },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Profil Kodu": item?.profileCode,
                  "İşlem Türü": item?.txnType,
                  "Banka Kodu": item?.bankcode,
                  "Onus": item?.onus ? "Evet":"Hayır",
                  "International": item?.international ? "Evet":"Hayır",
                  "Yi Amex": item?.amex ? "Evet":"Hayır",
                  "Kart Tipi": item?.cardType,
                  "Komisyonu Son Kullanıcıya Yansıt": item?.commissionFlag ? "Evet" : "Hayır",
                  "Üye İşyeri Ek Komisyonu": item?.merchantadditionalcommission,
                  "Üye İşyeri Komisyon Oranı": item?.merchantcommission,
                  "Minumum Tutar": item?.minAmount,
                  "Maksimum Tutar": item?.maxAmount,
                  "Taksit Sayısı":item?.installment
                };
              });
            }
            const refactoredData = fieldValue(data?.data);
            downloadExcel(refactoredData || [], "Komisyon Listesi");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          console.log(error);
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isDesktop ? 1300 : isSmallScreen ? "90%" : "70%",
          maxHeight: '90vh',  // eklenen satır
          maxWidth: '90vw',  // eklenen satır
          overflow: 'auto',  // eklenen satır
          bgcolor: "background.paper",
          border: "2px solid #2196f3",
          boxShadow: 24,
          p: 4,
          display: "relative",
        }}
      >
        <h2 id="modal-modal-title">Komisyon Listesi</h2>

        <Stack
          justifyContent="center"
          sx={{ width: 1, height: "90%", flexGrow: 1,overflowX: 'auto', }}
          
        >
          {tableData && (
            <>
                <Table
                 columnVisibilityConfigKey="comissionDetailModalColumnVisibilityKey"
                  paginationModel={paginationModel}
                  onPaginationModelChange={handleChangePagination}
                  paginationMode="server"
                  rowCount={tableData.totalItems}
                  sx={{
                    width: isDesktop ? 1240 : "auto",
                    height: isDesktop ? "600px" : "auto",
                  }}
                  isRowSelectable={() => false}
                  className="myTable"
                  disableColumnMenu
                  rows={tableData}
                  // hideFooterPagination
                  autoHeight={!isDesktop}
                  columns={columns}
                  exportFileName="Komisyon"
                  customLabelDisplayedRows={true}
                  onSave={() => onSave()}
                />
              {/* </div> */}
              <DeleteConfirmModal
                isOpen={isDeleteModalOpen}
                onClose={handleCloseDeleteModal}
                onConfirm={() => handleDeleteConfirm()}
              ></DeleteConfirmModal>
            </>
          )}
        </Stack>
        {/* <Button onClick={handleClose}>Close</Button> */}
        <IconButton
          sx={{
            position: "absolute",
            top: 2,
            right: 2,
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Modal>
  );
}
